import { render, staticRenderFns } from "./applyAcount.vue?vue&type=template&id=1d2cc370&"
import script from "./applyAcount.vue?vue&type=script&lang=js&"
export * from "./applyAcount.vue?vue&type=script&lang=js&"
import style0 from "./applyAcount.vue?vue&type=style&index=0&id=1d2cc370&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports